var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIkonNekad(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.763,
    height: 12.763,
    viewBox: "0 0 12.763 12.763",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Nekad",
    transform: "translate(-8129.086 -5897.332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_3703",
    "data-name": "Line 3703",
    d: "M11.263,12.013a.748.748,0,0,1-.53-.22L-.53.53A.75.75,0,0,1-.53-.53.75.75,0,0,1,.53-.53L11.793,10.733a.75.75,0,0,1-.53,1.28Z",
    transform: "translate(8129.836 5898.082)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3704",
    "data-name": "Line 3704",
    d: "M0,12.013a.748.748,0,0,1-.53-.22.75.75,0,0,1,0-1.061L10.733-.53a.75.75,0,0,1,1.061,0,.75.75,0,0,1,0,1.061L.53,11.793A.748.748,0,0,1,0,12.013Z",
    transform: "translate(8129.836 5898.082)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIkonNekad);
export default __webpack_public_path__ + "static/media/Ikon_Nekad.cf4a38f5268b4f148f4d11b420e2752f.svg";
export { ForwardRef as ReactComponent };